import { FC, useContext, useEffect } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { SharedRelatedBuyPages } from '../../shared/SharedRelatedBuyPages/SharedRelatedBuyPages';
import * as tracking from 'dibs-tracking';

import { BuySharedRelatedPages_buyPage } from './__generated__/BuySharedRelatedPages_buyPage.graphql';

type Props = {
    buyPage: BuySharedRelatedPages_buyPage;
};

const BuySharedRelatedPagesComponent: FC<Props> = ({ buyPage }) => {
    const { relatedBuyPages } = buyPage;
    const { isMobile } = useContext(ServerVarsContext);
    // relatedBuyPagesIdString is to prevent from useEffect firing twice
    const relatedBuyPagesIdString = relatedBuyPages?.map(page => page?.url).join();

    useEffect(() => {
        if (relatedBuyPagesIdString && relatedBuyPagesIdString.length) {
            tracking.trackEvent({
                category: 'navigation',
                action: 'top related links impression',
                label: 'buy page',
            });
        }
    }, [relatedBuyPagesIdString]);

    if (relatedBuyPages && relatedBuyPages.length) {
        return (
            <SharedRelatedBuyPages
                relatedBuyPages={relatedBuyPages}
                isFullWidth={isMobile}
                dataTn="buy-page-top-related-link-item"
                onClick={() =>
                    tracking.trackEvent({
                        category: 'navigation',
                        action: 'top related link click',
                        label: 'buy page',
                    })
                }
            />
        );
    }

    return null;
};

export const BuySharedRelatedPages = createFragmentContainer(BuySharedRelatedPagesComponent, {
    buyPage: graphql`
        fragment BuySharedRelatedPages_buyPage on ItemSearchQueryConnection {
            relatedBuyPages {
                anchorText
                url
            }
        }
    `,
});
